import * as React from "react";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { Grid } from "ui/grid/Grid";

import classnames from "classnames";

export const SplitScreenContainer = (props) => {
  const theme = useTheme();
  const classes = useStyles(props);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid className={classnames(classes.container, props.reverseContainer && classes.reverseContainer)} xl={12}>
      {props.simpleMobileDisplay && isMobile ? (
        <> </>
      ) : (
        <Grid item xl={12} md={8} lg={10} className={classes.boxWithBackground}>
          {props.logo && props.logoOnBackgroundImage && (
            <Grid className={classes.logo}>
              <props.logo />
            </Grid>
          )}
          {props.renderContentInImage && props.renderContentInImage()}
        </Grid>
      )}
      <Grid item xl={12} md={8} lg={10} className={classes.box}>
        {props.logo && !props.logoOnBackgroundImage && !isMobile && (
          <Grid className={classes.logo}>
            <props.logo />
          </Grid>
        )}
        {props.renderContent()}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    height: (props) => (props.isFullPage ? "100vh" : `calc(100vh - ${theme.spacing(10)}px)`),
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      display: "block",
      flexDirection: "column",
    },
  },
  reverseContainer: {
    flexDirection: "row-reverse",
  },
  box: {
    flexGrow: 1,
    margin: (props) => (props.centerText ? "auto" : 0),
    order: 2,
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(3),
    },
  },
  boxWithBackground: {
    flexGrow: 1,
    display: "flex",
    padding: theme.spacing(12, 6, 6, 8),
    backgroundImage: (props) => `url(${props.background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: theme.spacing(2),
      justifyContent: "center",
      alignItems: "center",
    },
  },
  logo: {
    alignSelf: "flex-start",
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(4.5),
      height: theme.spacing(4.5),
    },
  },
}));
